import { render, staticRenderFns } from "./MomoPaymentForm.vue?vue&type=template&id=09ffbb10&scoped=true"
import script from "./MomoPaymentForm.vue?vue&type=script&lang=js"
export * from "./MomoPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./MomoPaymentForm.vue?vue&type=style&index=0&id=09ffbb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ffbb10",
  null
  
)

export default component.exports